import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-date-time-picker',
    templateUrl: './date-time-picker.component.html',
    styleUrls: ['./date-time-picker.component.css'],
    standalone: false
})
export class DateTimePickerComponent {

  @Input() isSelectTime: boolean;
  @Input() displayDialog: boolean;
  @Input() maxFilterDate: Date;
  @Input() minFilterDate: Date;
  @Input() timeTo: String;
  @Input() timeFrom: String;
  @Input() top = 0;
  @Input() left = 0;
  @Output() onSubmit = new EventEmitter();

  constructor() {
  }

  selectCalendarFilterTo() {
    this.maxFilterDate = new Date(this.getDateFromString(this.timeTo));
  }

  selectCalendarFilterFrom() {
    this.minFilterDate = new Date(this.getDateFromString(this.timeFrom));
  }

  onClearAction() {
    this.timeFrom = undefined;
    this.timeTo = undefined;
    this.onSubmit.emit({"timeTo": this.timeTo, "timeFrom": this.timeFrom});
  }

  onOkAction() {
    this.onSubmit.emit({"timeTo": this.timeTo, "timeFrom": this.timeFrom});
  }

  //dd-mm-yyyy hh:mm to Date
  getDateFromString(dateString) {
    const [day, month, year] = dateString.split(" ")[0].split("-").map(Number);
    return new Date(year, month - 1, day);
  }

} 